/** @jsx jsx */
import { useTheme, css, jsx } from '@emotion/react';
import styled from '@emotion/styled';
import { Info, AlertOctagon, AlertTriangle } from 'react-feather';
import { shadows } from '../../theme';

const skipParagraph = css`
  .paragraph {
    &:first-child {
      margin-top: 0;
    }
    &:last-child {
      margin-bottom: 0;
    }
  }
`;

const WarningBox = () => {
  return (
    <div className="highlight-wrapper">
      <div style={{ marginRight: '16px', lineHeight: 0 }}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="feather feather-alert-triangle"
        >
          <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
          <line x1="12" y1="9" x2="12" y2="13" />
          <line x1="12" y1="17" x2="12.01" y2="17" />
        </svg>
        <div css={skipParagraph}>{children}</div>
      </div>
    </div>
  );
};

const HighlightWrapper = styled(({ className, children }) => <div className={className}>{children}</div>)`
  margin: 16px 0;
  padding: 14px;
  border-left: 5px solid ${(props) => props.border};
  background-color: ${(props) => props.background};
  color: ${(props) => props.font};
  align-items: center;
  display: flex;
  border-radius: 4px;
  box-shadow: ${(props) => shadows.boxShadowConfigurableColors(props.border)};
`;

const Highlight = ({ children, color, icon, ...props }) => {
  const theme = useTheme();
  const highlightColor = theme.highlights[color];
  return (
    <HighlightWrapper
      background={highlightColor.background}
      border={highlightColor.border}
      font={highlightColor.font}
      {...props}
    >
      <div css={{ marginRight: '16px', lineHeight: 0 }}>{icon.render({ color: highlightColor.border, size: 24 })}</div>
      <div css={skipParagraph}>{children}</div>
    </HighlightWrapper>
  );
};

export default {
  Warning: (props) =>
    Highlight({
      color: 'warning',
      icon: AlertTriangle,
      ...props
    }),
  Error: (props) =>
    Highlight({
      color: 'error',
      icon: AlertOctagon,
      ...props
    }),
  Info: (props) =>
    Highlight({
      color: 'info',
      icon: Info,
      ...props
    }),
  SubtleInfo: (props) =>
    Highlight({
      color: 'subtle-info',
      icon: Info,
      ...props
    }),
  Tip: (props) =>
    Highlight({
      color: 'tip',
      icon: Info,
      ...props
    })
};
